export function UserReadableError(message) {
    const err = new Error(message);
    err.userReadable = true;
    return err;
}

export function AggregateError(errors, message) {
    const err = new Error(message);
    err.errors = errors;
    err.isAggregate = true;
    err.UserReadableError = true;
    return err;
}